import { makeStyles } from "@material-ui/core/styles";

const destinationStyles = makeStyles(theme => ({
    root: {
        margin: "auto",
    },
    cardHeader: {
        padding: theme.spacing(1, 2),
    },
    cardShadow: {
        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.20)",
    },
    hoverShadow: {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "0 8px 16px 0 rgba(0, 0, 0, 0.20)",
        },
    },
    sideContainer: {
        width: "20%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    favLeft: {
        alignItems: "flex-start",
    },
    favorite: {
        position: "relative",
        right: "0px",
        float: "right",
    },
    favoriteSelected: {
        color: "gold",
    },
    circleRight: {
        alignItems: "flex-end",
    },
    checkCircle: {
        color: "#8BC34A",
        position: "relative",
        right: "0px",
    },
    destinationName: {
        fontFamily: "Roboto",
        fontSize: "13px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "1.1em",
    },
    list: {
        width: 400,
        height: 500,
        backgroundColor: theme.palette.background.paper,
        overflow: "auto",
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
}));
export default destinationStyles;
